/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { getApiEnv, serverUrls } from '@fai/constants/shared-urls';

export const environment = {
  IS_PRODUCTION: true,
  ENV_NAME: 'PRODUCTION',
  APP_NAME: 'friendli-suite',

  // Sentry
  SENTRY_DSN: process.env.NX_PUBLIC_SUITE_SENTRY_DSN,

  // Amplitude
  AMPLITUDE_API_KEY: process.env.NX_PUBLIC_SUITE_AMPLITUDE_API_KEY,
  AMPLITUDE_DEPLOYMENT_API_KEY: 'client-D5jfeH08NCZI98MqfAgcdtLZfThPjTbO',

  // Stripe
  STRIPE_PUBLISHABLE_KEY: process.env.NX_PUBLIC_SUITE_STRIPE_PUBLISHABLE_KEY,

  // LaunchDarkly
  LAUNCH_DARKLY_CLIENT_ID: '663dba716c59a410092a65f5',

  // Mintlify
  MINTLIFY_API_KEY: process.env.NX_PUBLIC_SUITE_MINTLIFY_API_KEY,

  ...getApiEnv(serverUrls.suite.production),
};
